import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class {
    constructor() {
        this.sliderContainerSelector = "audioguide-menu"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            const  swiper = new Swiper(item, {
                slidesPerView: 'auto',
                spaceBetween: 19,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.swiper-button-next`),
                    prevEl: item.parentElement.querySelector(`.swiper-button-prev`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        spaceBetween: 32,
                    },
                },
            });
            swiper.slides.forEach((slide, i) => {
                if (slide.classList.contains('_current')) {
                    swiper.slideTo(i);
                }
            })
        })
    }
})()
